import { createSlice } from "@reduxjs/toolkit"; // Importing createSlice from Redux Toolkit
import ConfigDB from "../../../Config/ThemeConfig"; // Importing configuration data for the theme

// Default values for the theme colors and layout settings from ConfigDB
const default_color = ConfigDB.data.color.primary_color; // Default primary color
const secondary_color = ConfigDB.data.color.secondary_color; // Default secondary color
const mix_layout = ConfigDB.data.color.mix_background_layout; // Default mixed background layout

// Initial state for the theme customizer slice
const initialState = {
  layout: ConfigDB.data.settings.layout_class, // Layout class from the config
  openCus: false, // Whether the customizer panel is open or not
  sidebarIconType: "fill", // Default sidebar icon type
  colorBackground1: default_color, // Primary background color
  colorBackground2: secondary_color, // Secondary background color
  mix_background_layout: mix_layout, // Mixed background layout setting
};

// ThemeCustomizerSlice is used to manage the theme customization state
const ThemeCustomizerSlice = createSlice({
  name: "ThemeCustomizer", // Slice name
  initialState, // Initial state defined above
  reducers: {
    // Reducer to set the layout class
    setLayout: (state, action) => {
      state.layout = action.payload; // Update the layout class with the new value
    },
    // Reducer to control the visibility of the customizer panel
    setOpenCus: (state, action) => {
      state.openCus = action.payload; // Update whether the customizer is open or closed
    },
    // Reducer to set the first background color
    setColorBackground1: (state, action) => {
      state.colorBackground1 = action.payload; // Update the first background color
    },
    // Reducer to set the second background color
    setColorBackground2: (state, action) => {
      state.colorBackground2 = action.payload; // Update the second background color
    },
    // Reducer to change the sidebar icon type and close the customizer panel
    addSidebarIconType: (state, action) => {
      // Update the sidebar icon type in the ConfigDB and state
      ConfigDB.data.settings.sidebar.iconType = action.payload;
      state.sidebarIconType = action.payload;
      state.openCus = false; // Close the customizer panel after applying changes
    },
    // Reducer to set the mixed background layout setting
    setMixBackgroundLayout: (state, action) => {
      state.mix_background_layout = action.payload; // Update the mixed background layout
    },
  },
});

// Exporting the actions to be used in the application for dispatching
export const {
  setMixBackgroundLayout,
  setColorBackground2,
  setColorBackground1,
  setOpenCus,
  addSidebarIconType,
  setLayout,
} = ThemeCustomizerSlice.actions;

// Exporting the reducer to be included in the Redux store
export default ThemeCustomizerSlice.reducer;
